import { render, staticRenderFns } from "./ApprovalPerformanceUser.vue?vue&type=template&id=794a6a85&scoped=true&"
import script from "./ApprovalPerformanceUser.vue?vue&type=script&lang=js&"
export * from "./ApprovalPerformanceUser.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalPerformanceUser.vue?vue&type=style&index=0&id=794a6a85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a6a85",
  null
  
)

export default component.exports